module.exports=[
  {
    "label": 1971,
    "amt": 5.97128115
  },
  {
    "label": 1972,
    "amt": 5.06861938
  },
  {
    "label": 1973,
    "amt": 5.13414157
  },
  {
    "label": 1974,
    "amt": 3.6069304
  },
  {
    "label": 1975,
    "amt": 4.40372632
  },
  {
    "label": 1976,
    "amt": 5.1655807
  },
  {
    "label": 1977,
    "amt": 8.59822428
  },
  {
    "label": 1978,
    "amt": 2.85152499
  },
  {
    "label": 1979,
    "amt": 3.49126725
  },
  {
    "label": 1980,
    "amt": 5.98856889
  },
  {
    "label": 1981,
    "amt": 4.09693313
  },
  {
    "label": 1982,
    "amt": 3.86431219
  },
  {
    "label": 1983,
    "amt": 6.59973252
  },
  {
    "label": 1984,
    "amt": 5.97192483
  },
  {
    "label": 1985,
    "amt": 4.84597604
  },
  {
    "label": 1986,
    "amt": 3.68504311
  },
  {
    "label": 1987,
    "amt": 3.56120827
  },
  {
    "label": 1988,
    "amt": 4.1383277
  },
  {
    "label": 1989,
    "amt": 2.20696706
  },
  {
    "label": 1990,
    "amt": 2.72787105
  },
  {
    "label": 1991,
    "amt": 3.78351913
  },
  {
    "label": 1992,
    "amt": 3.41234492
  },
  {
    "label": 1993,
    "amt": 6.42988329
  },
  {
    "label": 1994,
    "amt": 2.74084696
  },
  {
    "label": 1995,
    "amt": 2.51379247
  },
  {
    "label": 1996,
    "amt": 2.05023675
  },
  {
    "label": 1997,
    "amt": 2.10818249
  },
  {
    "label": 1998,
    "amt": 2.51052176
  },
  {
    "label": 1999,
    "amt": 2.43240146
  },
  {
    "label": 2000,
    "amt": 10.3998046
  },
  {
    "label": 2001,
    "amt": 15.7432801
  },
  {
    "label": 2002,
    "amt": 11.1894994
  },
  {
    "label": 2003,
    "amt": 5.54156762
  },
  {
    "label": 2004,
    "amt": 1.14678087
  },
  {
    "label": 2005,
    "amt": 2.41615958
  },
  {
    "label": 2006,
    "amt": 1.56716558
  },
  {
    "label": 2007,
    "amt": 0.84504355
  },
  {
    "label": 2008,
    "amt": 4.07437542
  },
  {
    "label": 2009,
    "amt": 4.00314079
  },
  {
    "label": 2010,
    "amt": 23.4415851
  },
  {
    "label": 2011,
    "amt": 1.98994608
  },
  {
    "label": 2012,
    "amt": 1.18035171
  },
  {
    "label": 2013,
    "amt": 1.93685772
  },
  {
    "label": 2014,
    "amt": 0.88908195
  },
  {
    "label": 2015,
    "amt": 1.20348009
  },
  {
    "label": 2016,
    "amt": 2.59406164
  },
  {
    "label": 2017,
    "amt": 1.44276355
  },
  {
    "label": 2018,
    "amt": 3.97981182
  }
]